import CreateLeader from "../organisms/leaders/CreateLeader";
import CardTables from "../atoms/CardTables";
import GlobalSearch from "../organisms/buscadores/GlobalSearch";
import TableLeaders from "../organisms/leaders/TableLeaders";
import Fuse from "fuse.js";
import { useEffect, useState } from "react";
import { GET_ADMINS } from "../../api/apiAdmin";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const LeadersTemplate = () => {
    const [admins, setAdmins] = useState();
    const [filteredAdmins, setFilteredAdmins] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ user: "", email: "" });

    const getAdmins = async () => {
		try {
            setLoading(true);
			const adminsData = await GET_ADMINS();
            const filterData = adminsData.filter(admin => !admin.isSuperAdmin);
            const sortedData = filterData.sort((a, b) => a.id - b.id);
            setAdmins(sortedData);
            setFilteredAdmins(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	};

	useEffect(() => { 
        getAdmins(); 
    }, []);

    useEffect(() => {
        if (!admins) return;

        const options = {
            keys: ["name", "user.email"],
            threshold: 0.3,
        };

        const fuse = new Fuse(admins, options);

        const searchTerms = `${filters.user} ${filters.email}`.trim();

        if (searchTerms) {
            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredAdmins(results);
        } else {
            setFilteredAdmins(admins);
        }
    }, [filters, admins]);

    return(
        <div className="h-full w-full flex flex-col space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Usuarios", to: "/usuarios" },
                        { label: "Lideres de contabilidad", to: null },
                    ]}
                />
                <CreateLeader refetch={getAdmins} />
            </CardHeader>
            <CardTables>
                <GlobalSearch filters={filters} setFilters={setFilters} />
                <TableLeaders loading={loading} data={filteredAdmins} refetch={getAdmins}/>
            </CardTables>
        </div>
    )
};

export default LeadersTemplate;